export default __webpack_public_path__ + "static/media/YE.88d94a3f.svg";